import { useQueryClient } from "@tanstack/react-query";
import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Download01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { LockboxAccountsList } from "views/settings-integration/integrations/shared/LockboxAccountsList";
import { LockboxCredentialsTab } from "views/settings-integration/integrations/shared/LockboxCredentialsTab";
import { ImportLockboxesModal } from "./components/ImportLockboxesModal";

export const CodeboxView = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [importModalOpen, setImportModalOpen] = useState(false);

  const handleImportSuccess = useCallback(() => {
    setImportModalOpen(false);
    queryClient.invalidateQueries({ queryKey: ["LOCKBOXES"] });
    navigate("/settings/integration");
  }, [queryClient, navigate]);

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.CODEBOX}
          name="Codebox"
          path="/settings/integration/codebox"
          actions={
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              HugeIcon={Download01Icon}
              onClick={() => setImportModalOpen(true)}
            >
              Import lockboxes
            </Button>
          }
        />
      }
    >
      <LockboxCredentialsTab />
      <LockboxAccountsList vendor="codebox" />
      <ImportLockboxesModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
    </Layout>
  );
};
